export default __webpack_public_path__ + "static/media/csv-valid-rows.3dd22279.svg";